import { createSlice } from '@reduxjs/toolkit';
import { addOrderToBasket } from './actions/addOrderToBasket';
import { addProductToBasket } from './actions/addProductToBasket';
import { deleteProduct } from './actions/deleteProduct';
import { retrieveBasket } from './actions/retrieveBasket';
import { updateBasketDelivery } from './actions/updateBasketDelivery';
import { updateBasketProduct } from './actions/updateBasketProduct';
import { validateBasket } from './actions/validateBasket';
const INITIAL_STATE = {
    drawer: 'closed',
    items: undefined,
    offDate: undefined,
    onDate: undefined,
    paymentSummary: undefined,
    productErrors: undefined,
    productId: '',
    status: 'fulfilled',
    totalQuantity: undefined,
    upsell: undefined,
    version: 0,
};
export const basket = createSlice({
    name: 'basket',
    initialState: INITIAL_STATE,
    reducers: {
        setStatus(state, action) {
            state.status = action.payload;
        },
        setProductId(state, action) {
            state.productId = action.payload;
        },
        setDrawerStatus(state, action) {
            state.drawer = action.payload;
        },
        setBasketVersion(state, action) {
            state.version = action.payload;
        },
    },
    extraReducers(builder) {
        builder.addCase(addProductToBasket.fulfilled, (state, action) => {
            state.status = 'fulfilled';
            state.items = action.payload.items;
            state.onDate = action.payload.onDate;
            state.offDate = action.payload.offDate;
            state.paymentSummary = action.payload.paymentSummary;
            state.totalQuantity = action.payload.totalQuantity;
            state.productId = '';
            state.upsell = action.payload.upsell;
            state.productErrors = action.payload.productErrors;
        });
        builder.addCase(addOrderToBasket.fulfilled, (state, action) => {
            state.status = 'fulfilled';
            state.items = action.payload.items;
            state.onDate = action.payload.onDate;
            state.offDate = action.payload.offDate;
            state.paymentSummary = action.payload.paymentSummary;
            state.totalQuantity = action.payload.totalQuantity;
            state.upsell = action.payload.upsell;
            state.productErrors = action.payload.productErrors;
        });
        builder.addCase(retrieveBasket.fulfilled, (state, action) => {
            state.status = 'fulfilled';
            state.items = action.payload.items;
            state.onDate = action.payload.onDate;
            state.offDate = action.payload.offDate;
            state.paymentSummary = action.payload.paymentSummary;
            state.totalQuantity = action.payload.totalQuantity;
            state.upsell = action.payload.upsell;
            state.productErrors = action.payload.productErrors;
        });
        builder.addCase(updateBasketProduct.fulfilled, (state, action) => {
            state.status = 'fulfilled';
            state.items = action.payload.items;
            state.paymentSummary = action.payload.paymentSummary;
            state.totalQuantity = action.payload.totalQuantity;
            state.productId = '';
            state.upsell = action.payload.upsell;
            state.productErrors = action.payload.productErrors;
        });
        builder.addCase(deleteProduct.fulfilled, (state, action) => {
            state.status = 'fulfilled';
            state.items = action.payload.items;
            state.paymentSummary = action.payload.paymentSummary;
            state.totalQuantity = action.payload.totalQuantity;
            state.productId = '';
            state.upsell = action.payload.upsell;
            state.productErrors = action.payload.productErrors;
        });
        builder.addCase(updateBasketDelivery.fulfilled, (state, action) => {
            state.status = 'fulfilled';
            state.paymentSummary = action.payload.paymentSummary;
        });
        builder.addCase(validateBasket.fulfilled, (state, action) => {
            state.status = 'fulfilled';
            state.productErrors = action.payload.productErrors;
        });
    },
});
